import {
  compose,
  withProps,
  mapProps,
  branch,
  renderComponent
} from 'recompose'
import { Field } from 'formik'
import { find } from 'lodash'
import Select from 'react-select'
import Creatable from 'react-select/lib/Creatable'

const SelectField = compose(
  mapProps(({ form, field, options, ...props }) => ({
    ...props,
    options,
    value: field.value && find(options, { value: field.value }),
    onBlur: () => form.setFieldTouched(field.name, true),
    onChange: opt => {
      if (!opt) return
      form.setFieldValue(field.name, opt.value)
      props.onChange && props.onChange(opt.value)
    }
  })),
  branch(({ isClearable }) => isClearable, renderComponent(Creatable))
)(Select)

export default withProps({ component: SelectField })(Field)
